// Frontend email service that communicates with the backend

const sendEmail = async ({ to, subject, text, html }) => {
  try {
    const response = await fetch('/api/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ to, subject, text, html }),
    });

    const data = await response.json();
    if (!data.success) {
      throw new Error(data.error || 'Failed to send email');
    }

    return data;
  } catch (error) {
    console.error('Email error:', error);
    throw error;
  }
};

// Template for consent confirmation
export const sendConsentConfirmation = async (memberEmail, memberName) => {
  const subject = 'Rotary Club Text Message Consent Confirmation';
  const html = `
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
      <h2>Consent Confirmation</h2>
      <p>Dear ${memberName},</p>
      <p>This email confirms that you have provided consent to receive text messages from the Rotary Club.</p>
      <p>If you did not authorize this consent, please contact us immediately.</p>
      <br>
      <p>Best regards,</p>
      <p>Your Rotary Club</p>
    </div>
  `;

  return sendEmail({
    to: memberEmail,
    subject,
    text: html.replace(/<[^>]*>/g, ''), // Strip HTML for text version
    html,
  });
};

// Template for welcome email
export const sendWelcomeEmail = async (memberEmail, memberName) => {
  const subject = 'Welcome to Rotary Club Text Messaging Service';
  const html = `
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
      <h2>Welcome to Rotary Club!</h2>
      <p>Dear ${memberName},</p>
      <p>Welcome to our text messaging service. You'll now receive important updates and announcements from the Rotary Club.</p>
      <p>To ensure you receive our messages:</p>
      <ul>
        <li>Make sure your phone number is up to date</li>
        <li>Add our number to your contacts</li>
        <li>Reply STOP at any time to opt out</li>
      </ul>
      <br>
      <p>Best regards,</p>
      <p>Your Rotary Club</p>
    </div>
  `;

  return sendEmail({
    to: memberEmail,
    subject,
    text: html.replace(/<[^>]*>/g, ''),
    html,
  });
};

// Template for consent revocation confirmation
export const sendConsentRevocationEmail = async (memberEmail, memberName) => {
  const subject = 'Rotary Club Text Message Consent Revoked';
  const html = `
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
      <h2>Consent Revocation Confirmation</h2>
      <p>Dear ${memberName},</p>
      <p>This email confirms that your consent to receive text messages from the Rotary Club has been revoked.</p>
      <p>You will no longer receive text messages from us. If you would like to re-enable text messages in the future, please contact your administrator.</p>
      <br>
      <p>Best regards,</p>
      <p>Your Rotary Club</p>
    </div>
  `;

  return sendEmail({
    to: memberEmail,
    subject,
    text: html.replace(/<[^>]*>/g, ''),
    html,
  });
};
